import { baseApi, SHOP_COMMISSIONS_TAG } from '@/shared';

import { shopCommissionsAdapter } from '../utils/helpers/adapter';

import type {
  TGetShopCommissionsParams,
  TShopCommissionResponse,
  TShopCommissionCreateParams,
  TShopCommissionUpdateParams,
  TShopCommissionDeleteParams,
} from './types';

export const shopCommissionsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getShopCommissions: build.query<TShopCommissionResponse, TGetShopCommissionsParams>({
      query: (params) => ({
        url: '/admin/shop_commissions/list',
        params: {
          page_size: params.pageSize,
          page: params.page,
          ascending: params.ascending,
        },
      }),
      transformResponse: shopCommissionsAdapter,
      providesTags: [SHOP_COMMISSIONS_TAG],
    }),

    createShopCommission: build.mutation<void, TShopCommissionCreateParams>({
      query: (params) => ({
        url: '/admin/shop_commissions/create',
        method: 'POST',
        body: {
          shop_id: params.shopId,
          payment_method_id: params.paymentMethodId,
          refill_percent: params.refillPercent,
          additional_percent: params.additionalPercent,
        },
      }),
      invalidatesTags: [SHOP_COMMISSIONS_TAG],
    }),

    updateShopCommission: build.mutation<void, TShopCommissionUpdateParams>({
      query: ({ commissionId, ...params }) => ({
        url: `/admin/shop_commissions/update/${commissionId}`,
        method: 'PUT',
        params: {
          refill_percent: params.refillPercent,
          additional_percent: params.additionalPercent,
        },
      }),
      invalidatesTags: [SHOP_COMMISSIONS_TAG],
    }),

    deleteShopCommission: build.mutation<void, TShopCommissionDeleteParams>({
      query: ({ commissionId }) => ({
        url: `/admin/shop_commissions/delete/${commissionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [SHOP_COMMISSIONS_TAG],
    }),

  }),
});

export const {
  useGetShopCommissionsQuery,
  useCreateShopCommissionMutation,
  useUpdateShopCommissionMutation,
  useDeleteShopCommissionMutation,
} = shopCommissionsApi;
